import { Circle } from 'src/api/circles';
import api from './baseApi';

export enum SubscriptionStatus {
  CREATING = 'CREATING',
  ACTIVE = 'ACTIVE',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
}

export enum SubscriptionType {
  AUCTION = 'AUCTION',
  FIXED = 'FIXED',
}

export enum PaymentPeriod {
  // Payment periods match Stripe definitions
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export interface Subscription {
  _id: string;
  createdAt: string;
  updatedAt: string;

  tribe: Circle;
  status: SubscriptionStatus;
  subscription_type: SubscriptionType;
  tribe_id: string;
  user_id: string;
  bid_ids: string[];
  total_amount_usd: number;
  price_per_seat_usd: number;
  seat_count: number;
  payment_period: PaymentPeriod;
  nextBillingDate: string;
}

export const subscriptionsApi = {
  getSubscriptions: async (): Promise<Subscription[]> => {
    const axiosResponse = await api.get(`subscriptions`);
    return axiosResponse.data.result;
  },

  cancelSubscription: async (subscription_id: string): Promise<void> => {
    try {
      await api.patch(`subscriptions/${subscription_id}/cancel`, {});
      return;
    } catch (error: any) {
      const status = error?.response?.status;
      if (status !== 404 && status !== 405) {
        throw error;
      }
    }

    await api.delete(`subscriptions/${subscription_id}`);
  },

  editCreditCard: async (
    subscription_id: string
  ): Promise<{ redirectUrl: string }> => {
    const axiosResponse = await api.patch(
      `subscriptions/${subscription_id}/update-payment`,
      {}
    );
    return axiosResponse.data.result;
  },
};
